import React from 'react';
import ReactDOM from 'react-dom/client';

class ScrollTop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showScrollTop: false,
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.checkScrollTop);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.checkScrollTop);
    }

    checkScrollTop = () => {
        if (!this.state.showScrollTop && window.pageYOffset > 300) {
            this.setState({showScrollTop: true});
        } else if (this.state.showScrollTop && window.pageYOffset <= 300) {
            this.setState({showScrollTop: false});
        }
    }

    scrollTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    render() {
        return (
            <>
                {this.state.showScrollTop &&
                    <div className="fixed sm:bottom-5 bottom-2 sm:right-12 right-2 z-50">
                        <button onClick={this.scrollTop}
                                className="flex items-center justify-center px-5 py-[9px] border border-solid border-dark-main rounded-full bg-white/[0.74]">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 19L12 5" stroke="#14181F" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M6 11L12 5L18 11" stroke="#14181F" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>
                }
            </>
        );
    }
}

const section = document.getElementById('scroll_top');
if (section) {
    const root = ReactDOM.createRoot(document.getElementById('scroll_top'));
    root.render(<ScrollTop/>);
}
